import MapWithDragSearch from './map-with-drag-search';

export default MapWithDragSearch;
